import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { categories, MAIN_SITE_URL } from "@/mocks/categories";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="border-t border-background-200/80 bg-background-100">
      <div className="mx-auto w-full px-4 py-12 md:px-6 lg:px-10">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-links-line"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">
                {t("brand.name")}
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              {t("footer.about")}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-foreground-950">
              {t("footer.resources")}
            </h4>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-600 transition-colors hover:text-primary-700">
                  {t("nav.home")}
                </Link>
              </li>
              <li>
                <Link to="/usfans-spreadsheet-guide" className="text-sm text-foreground-600 transition-colors hover:text-primary-700">
                  {t("nav.guide")}
                </Link>
              </li>
              <li>
                <Link to="/#categories" className="text-sm text-foreground-600 transition-colors hover:text-primary-700">
                  {t("nav.categories")}
                </Link>
              </li>
              <li>
                <Link to="/#faq" className="text-sm text-foreground-600 transition-colors hover:text-primary-700">
                  {t("nav.faq")}
                </Link>
              </li>
              <li>
                <a
                  href={MAIN_SITE_URL}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 transition-colors hover:text-primary-700"
                >
                  {t("nav.explore")}
                </a>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-1">
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-foreground-950">
              {t("footer.categories")}
            </h4>
            <ul className="mt-4 grid grid-cols-2 gap-2.5">
              {categories.map((c) => (
                <li key={c.key}>
                  <a
                    href={c.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-700"
                  >
                    {t(`cat.${c.key}`)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-foreground-950">
              {t("footer.languages")}
            </h4>
            <div className="mt-4 flex flex-wrap gap-2">
              {["EN", "PL", "ES", "FR"].map((lang) => (
                <span
                  key={lang}
                  className="rounded-full border border-background-300 px-3 py-1 text-xs font-medium text-foreground-700"
                >
                  {lang}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 border-t border-background-200 pt-6">
          <p className="text-xs leading-relaxed text-foreground-500">
            {t("footer.disclaimer")}
          </p>
          <p className="mt-4 text-xs text-foreground-400">
            © {new Date().getFullYear()} {t("brand.name")}. {t("footer.rights")}
          </p>
        </div>
      </div>
    </footer>
  );
}